import { ITextFieldProps, ILabelProps } from "./types";
import { forwardRef } from "react";
import { Box, Stack, TextField as TextFieldMui, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import FormLabel from "components/FormLabel";

const TextFieldMuiCustom = styled(TextFieldMui)<{ loading: 0 | 1 }>(
  ({ theme, variant, error, disabled, loading }) => ({
    "& .MuiInputBase-root.MuiFilledInput-root": {
      background: "#f5f5f5 !important",
      backgroundColor: "#f5f5f5 !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: variant === "outlined" ? theme.palette.error.content : theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      // color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
      marginLeft: "0px",
    },
    "& .MuiInputBase-input.MuiFilledInput-input": {
      paddingTop: "12px !important",
      background: "#f5f5f5 !important",
    },
    "& .MuiInput-underline:before": {
      borderBottom: `2px solid ${
        disabled
          ? "rgba(0, 0, 0, 0.12)"
          : error
          ? theme.palette.error.main
          : theme.palette.primary.main
      }!important`,
    },
    "& .MuiFilledInput-input.Mui-disabled": {
      borderBottom: loading ? "none" : "2px solid rgba(0, 0, 0, 0.12) !important",
      background: "#fafafa",
    },
    "&.MuiInputBase-input": {
      background: "#f5f5f5 ",
    },
    ".MuiInputBase-root.MuiFilledInput-root.Mui-disabled:before": {
      borderBottomStyle: "none",
    },
    ".MuiOutlinedInput-notchedOutline": {
      // borderColor: "rgba(0,0,0,0.12)",
      // borderWidth: "1px",
      //border: `2px solid ${theme.palette.text.disabled}`,
    },
    ".MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    ".MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled": {
      background: "#f5f5f5",
    },
  })
);

const TextField = forwardRef<any, ITextFieldProps & TextFieldProps>(
  (
    {
      error,
      disabled,
      label,
      className,
      variant = "filled",
      loading,
      InputLabelProps,
      fullWidth = true,
      direction = "column",
      endAdornment,
      inputAdornment,
      ...props
    },
    ref
  ) => {
    return (
      <FormLabel
        disabled={disabled}
        label={label}
        fullWidth={fullWidth}
        direction={direction}
        id={props.id}
        {...InputLabelProps}
      >
        <Box display={"inherit"} sx={{ width: 1 }}>
          <Box sx={{ width: "100%", position: "relative" }}>
            <TextFieldMuiCustom
              ref={ref}
              {...props}
              className={className}
              variant={variant}
              loading={loading ? 1 : 0}
              error={error}
              disabled={disabled}
              fullWidth={true}
            />
            {inputAdornment}
          </Box>
          {endAdornment}
        </Box>
      </FormLabel>
    );
  }
);

export default TextField;

export { default as NumberFormatCustom } from "./NumberFormatCustom";
